<template>
  <!-- Client-only overlay (not in the server HTML), so first paint shows the real page.
       Fixed + inset-0 keeps it out of the layout; it animates transform/opacity only. -->
  <div v-if="visible" ref="root" class="fixed inset-0 intro_container z-[1100]" aria-hidden="true">

    <!-- text container -->
    <div class="absolute z-[3] inset-0 grid place-content-center">
      <div class="overflow-hidden">
        <div class="relative text_container">
          <h3 class="text-5xl font-pp-bolder text-primary-light">Echopus</h3>
          <h3 class="absolute top-0 left-0 text-5xl font-pp-bolder filledText text-primary">Echopus</h3>
        </div>
      </div>
    </div>

    <!-- first overlay  -->
    <div class="absolute inset-0 first_charts_container z-[2] flex">
      <div v-for="i in 4" :key="i" class="w-1/4 h-full bg-dark"></div>
    </div>

    <!-- second overlay  -->
    <div class="absolute inset-0 second_charts_container z-[1] flex">
      <div v-for="i in 4" :key="i" class="w-1/4 h-full bg-primary"></div>
    </div>

  </div>
</template>

<script setup>
import { nextTick, onBeforeUnmount, onMounted, ref } from "vue";

const SEEN_KEY = "echopus_intro_seen";

const visible = ref(false);
const root = ref(null);
let ctx;

onMounted(async () => {
  if (!useAppConfig().site.intro) return;
  // Once per browser session, and never for visitors who prefer reduced motion.
  let seen = false;
  try {
    seen = sessionStorage.getItem(SEEN_KEY) === "1";
    sessionStorage.setItem(SEEN_KEY, "1");
  } catch {}
  if (seen || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  visible.value = true;
  const [{ gsap }] = await Promise.all([loadGsap(), nextTick()]);
  if (!root.value) return;

  ctx = gsap.context(() => {
    gsap
      .timeline({ defaults: { ease: "power2.inOut" }, onComplete: () => (visible.value = false) })
      .to(".filledText", {
        clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
        duration: 1.1,
        ease: "power3.out",
      })
      .to(".text_container", {
        delay: 0.85,
        yPercent: -100,
        duration: 0.6,
      })
      .to(".first_charts_container > div", {
        yPercent: -100,
        duration: 0.4,
        stagger: 0.0285,
      })
      .to(".second_charts_container > div", {
        yPercent: -100,
        duration: 0.35,
        stagger: 0.005,
      });
  }, root.value);
});

onBeforeUnmount(() => ctx?.revert());
</script>

<style scoped>
.filledText {
  clip-path: polygon(0 4%, 0 0, 0 100%, 0 100%);
  transition: 1.05s ease-out;
  transition-timing-function: cubic-bezier(0.85, 0.08, 0.09, 0.94);
}

.text_container {
  transition: 0.2s ease-out;
  transition-timing-function: cubic-bezier(0.79, 0.05, 1, 0.82) !important;
}

.first_charts_container > div,
.second_charts_container > div {
  will-change: transform;
}
</style>
